import { render, staticRenderFns } from "./lanShouOrders.vue?vue&type=template&id=f86ca694&scoped=true"
import script from "./lanShouOrders.vue?vue&type=script&lang=js"
export * from "./lanShouOrders.vue?vue&type=script&lang=js"
import style0 from "./lanShouOrders.vue?vue&type=style&index=0&id=f86ca694&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f86ca694",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/work/jenkins/workspace/pre环境/快递系统/快递前端/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('f86ca694')) {
      api.createRecord('f86ca694', component.options)
    } else {
      api.reload('f86ca694', component.options)
    }
    module.hot.accept("./lanShouOrders.vue?vue&type=template&id=f86ca694&scoped=true", function () {
      api.rerender('f86ca694', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/collectionCenter/Order/lanShouOrders.vue"
export default component.exports